export default __webpack_public_path__ + "static/media/trr-event-brunch.e246a69e.png";